export class Footer {
  public render(): string {
    const currentYear = new Date().getFullYear()

    return `
      <footer class="mt-auto border-t border-primary-100/80 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div class="flex flex-col md:flex-row justify-between items-center gap-6">
            <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm text-slate-600 dark:text-slate-400 text-center md:text-left">
              <span>© ${currentYear} Sovran AI</span>
              <span class="hidden sm:inline text-primary-200 dark:text-gray-600">·</span>
              <span class="text-slate-500 dark:text-slate-500">One-time secrets</span>
            </div>

            <div class="flex flex-wrap items-center justify-center gap-6 text-sm">
              <div class="flex items-center gap-2 text-success-600 dark:text-success-400">
                <svg class="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                </svg>
                <span class="font-medium">End-to-end protection</span>
              </div>
              <div class="text-slate-400 dark:text-slate-600">
                <span class="hidden sm:inline">v1.0.0</span>
              </div>
            </div>
          </div>

          <div class="mt-6 pt-6 border-t border-slate-100 dark:border-gray-800 md:hidden">
            <div class="text-xs text-slate-500 dark:text-slate-500 text-center space-y-1">
              <div class="flex items-center justify-center gap-1.5">
                <svg class="w-3.5 h-3.5 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
                <span>Based on One-Time Secret</span>
              </div>
              <p>Content encrypted and deleted after viewing</p>
            </div>
          </div>
        </div>
      </footer>
    `
  }
}
